import { SVGProps } from 'react';

const ThumbScaleSmallKindDownReducedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M9.99996 3.33332V8.99999M12.6666 7.53332V4.26666C12.6666 3.75119 12.2381 3.33332 11.7095 3.33332H5.28457C4.57599 3.33332 3.97339 3.83748 3.86564 4.52044L3.3503 7.78711C3.2165 8.63517 3.88935 9.39999 4.76922 9.39999H6.44562C6.70991 9.39999 6.92416 9.60892 6.92416 9.86666V11.5159C6.92416 12.1515 7.45246 12.6667 8.10416 12.6667C8.2596 12.6667 8.40046 12.5774 8.46359 12.4389L10.1476 8.74379C10.2244 8.57527 10.3958 8.46666 10.5849 8.46666H11.7095C12.2381 8.46666 12.6666 8.04879 12.6666 7.53332Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ThumbScaleSmallKindDownReducedTrue;
